import folderStore, { getEffectiveFolderDisplayName } from 'owa-folders';
import type { MailFolder } from 'owa-graph-schema';
import mailStore from 'owa-mail-store/lib/store/Store';
import type DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';
import type Item from 'owa-service/lib/contract/Item';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';

const APPOINTMENT_CLASS_NAME = 'IPM.Appointment';
const CONTACT_CLASS_NAME = 'IPM.Contact';
const DISTRIBUTION_LIST_CLASS_NAME = 'IPM.DistList';
const TASK_CLASS_NAME = 'IPM.Task';
const CALENDAR_FOLDERID_NAME: DistinguishedFolderIdName = 'calendar';
const CONTACTS_FOLDERID_NAME: DistinguishedFolderIdName = 'contacts';
const TASK_FOLDERID_NAME: DistinguishedFolderIdName = 'tasks';
const INBOX_FOLDERID_NAME: DistinguishedFolderIdName = 'inbox';

export function isUnsupportedItem(item: Item): boolean {
    return (
        item &&
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2345 (23,33): Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        // @ts-expect-error
        (isAppointmentItemClass(item.ItemClass) ||
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2345 (27,32): Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            // @ts-expect-error
            isContactItemClass(item.ItemClass) ||
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2345 (31,41): Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            // @ts-expect-error
            isDistributionListItemClass(item.ItemClass) ||
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2345 (35,29): Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            // @ts-expect-error
            isTaskItemClass(item.ItemClass))
    );
}

export function getUnsupportedItemIdFromConversation(conversationId: string): string {
    const itemParts = mailStore.conversations.get(conversationId);
    const conversationNode = mailStore.conversationNodes.get(
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2345 (45,9): Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        // @ts-expect-error
        itemParts && itemParts.conversationNodeIds[0]
    );
    if (conversationNode) {
        const itemId = conversationNode.itemIds[0];
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2345 (52,31): Argument of type 'ClientItem | undefined' is not assignable to parameter of type 'Item'.
        // @ts-expect-error
        if (isUnsupportedItem(mailStore.items.get(itemId))) {
            return itemId;
        }
    }

    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (60,5): Type 'null' is not assignable to type 'string'.
    // @ts-expect-error
    return null;
}

export function getDefaultFolderId(itemId: string): string {
    const item = mailStore.items.get(itemId);
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2532 (68,32): Object is possibly 'undefined'.
    // @ts-expect-error
    if (isAppointmentItemClass(item.ItemClass)) {
        return folderNameToId(CALENDAR_FOLDERID_NAME, item?.MailboxInfo);
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2532 (73,35): Object is possibly 'undefined'.
        // @ts-expect-error
    } else if (isContactItemClass(item.ItemClass) || isDistributionListItemClass(item.ItemClass)) {
        return folderNameToId(CONTACTS_FOLDERID_NAME, item?.MailboxInfo);
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2532 (78,32): Object is possibly 'undefined'.
        // @ts-expect-error
    } else if (isTaskItemClass(item.ItemClass)) {
        return folderNameToId(TASK_FOLDERID_NAME, item?.MailboxInfo);
    } else {
        return folderNameToId(INBOX_FOLDERID_NAME, item?.MailboxInfo);
    }
}

export function getFolderName(folderId: string): string {
    let folderName = '';
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (90,11): Type 'MailFolder | undefined' is not assignable to type 'MailFolder'.
    // @ts-expect-error
    const folder: MailFolder = folderStore.folderTable.get(folderId);
    if (folder) {
        folderName = getEffectiveFolderDisplayName(folder);
    }

    return folderName;
}

function isAppointmentItemClass(itemClass: string): boolean {
    return itemClass.indexOf(APPOINTMENT_CLASS_NAME) == 0;
}

function isContactItemClass(itemClass: string): boolean {
    return itemClass.indexOf(CONTACT_CLASS_NAME) == 0;
}

function isDistributionListItemClass(itemClass: string): boolean {
    return itemClass.indexOf(DISTRIBUTION_LIST_CLASS_NAME) == 0;
}

function isTaskItemClass(itemClass: string): boolean {
    return itemClass.indexOf(TASK_CLASS_NAME) == 0;
}
